import { CategoryConfigurationStatus, CategoryType } from 'src/graphql';

export function filterCategoriesEligibleForNewForm(
  categories: CategoryType[] | null | undefined,
  isCoiForm: boolean,
): CategoryType[] {
  if (!categories?.length) return [];
  return categories.filter((cat) => {
    if (!cat.isCustomQuestions) return false;

    // For COI forms: allow Active and FormRequired (not Inactive)
    if (isCoiForm) {
      return (
        cat.status === CategoryConfigurationStatus.FormRequired ||
        cat.status === CategoryConfigurationStatus.Active
      );
    }

    // For other form types: only FormRequired
    return cat.status === CategoryConfigurationStatus.FormRequired;
  });
}
